// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"173":"a28abfe1","453":"b5898472"}[chunkId] + ".chunk.js";
};